import { useMemo } from 'react'
import usePolicies from './usePolicies'

export const usePolicy = (policyName) => {
  const policies = usePolicies()
  return useMemo(() => {
    return policies[policyName] === true
  }, [policies, policyName])
}
